import React from 'react';
import { Application } from '../../../models';
import { SchoolIcon } from '../../icons';
import EducationForm from './EducationForm';

interface FourStepProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function FourthStep({
  application = null,
  isReadOnly = false,
}: FourStepProps) {
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="w-20 h-20 rounded-full bg-[#FFCFE6] border border-[#FFAED5] flex">
        <SchoolIcon className="h-12 w-12 m-auto text-magenta" />
      </div>
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">Education</h2>
      </div>
      <div className="mt-8 flex flex-col">
        <EducationForm
          application={application}
          education={application?.education}
          isReadOnly={isReadOnly}
        />
      </div>
    </div>
  );
}
